// Shared kind → emoji map for calendar chips/rows (used by the grid + the class
// schedule panel). Kept in one place so the two surfaces never drift.
import type { CalendarEntryKind } from "@/api/calendar";

export const KIND_ICON: Record<CalendarEntryKind, string> = {
  homework: "📘",
  block: "⏳",
  task: "✓",
};
